import Divider, { DividerProps } from '@mui/material/Divider';
import React from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';

type Props = {
  flexItem?: DividerProps['flexItem'];
  orientation?: DividerProps['orientation'];
};

export const ViewDivider: React.FC<Props> = props => {
  return <Divider sx={{ borderColor: themeColors.divider, m: 0 }} {...props} />;
};
